
















































































































































































































































































































































































































































































































































































































































































































































































































































import { types } from '../../store/types/types.js';
import { exitTypes } from '../../../shared/enums/exitTypes';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment-timezone';
import { presenceModules } from '../../../shared/enums/presenceModules.js';
import { pickupTypes } from '../../../shared/enums/pickupTypes.js';
import { dateFormatTypes } from '../../../shared/enums/dateFormatTypes.js';
import { presenceOpenHours } from '../../../shared/enums/presenceOpenHours';
import cloneDeep from 'lodash/cloneDeep';
import $ from 'jquery';
import { comeGoUtil } from '../../../shared/utils/comeGoUtil.js';
import Timepicker from '../../../shared/components/Timepicker.vue';
import { timepickerSettings } from '../../../shared/enums/timepickerSettings.js';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import * as dateUtil from '../../../shared/utils/dateUtil.js';
import AulaButton from '../../../shared/components/AulaButton.vue';
import { dateFormatEnum } from '../../../shared/enums/dateFormatEnum';
import { DateTimeUtil } from '../../../shared/utils/dateTimeUtil';
import Avatar from '../../../shared/components/Avatar.vue';
import { PresenceTemplateRepeatPatternEnum } from '../../../shared/enums/presenceTemplateRepeatPattern.enum';
import DatePicker from '../../../shared/components/ui/DatePicker.vue';
import { usePresenceTemplates } from '../../composables/presence/usePresenceTemplates';

export default {
  components: { DatePicker, Avatar, AulaButton, Icon, Timepicker },
  setup() {
    const { isPatternChanged, getIsRepeating, getRepeatingInfoWithStartWeek, getRepeatingInfoWithEndDate } =
      usePresenceTemplates();
    return {
      isPatternChanged,
      getIsRepeating,
      getRepeatingInfoWithStartWeek,
      getRepeatingInfoWithEndDate,
    };
  },
  data: function () {
    return {
      repeatDateFormat: dateFormatEnum.COMPLETE_DATE,
      timepickerSettings: timepickerSettings,
      presenceOpenHours: presenceOpenHours,
      exitTypes: exitTypes,
      presenceModules: presenceModules,
      isLoading: false,
      isLoadingTemplate: false,
      datepickerDate: null,
      presenceTimes: [],
      viewPresenceProfile: null,
      editPresenceProfile: null,
      isEditingLoading: false,
      isEditingTemplate: false,
      newPickupResponsible: '',
      showAlertTooShortName: false,
      currentWeekView: [],
      matchedNames: [],
      editTemplateProfileIndex: null,
      editTemplatePresenceIndex: null,
      editTemplateDayIndex: null,
      availableDate: {
        disabledDate(time) {
          return (
            time.getTime() + 86400000 < moment().startOf('week').toDate().getTime() ||
            time.getTime() + 86400000 > moment().add(1, 'year').toDate().getTime()
          );
        },
        firstDayOfWeek: 1,
      },
      isMissingEntryTimeAlertVisible: false,
      isMissingExitTimeAlertVisible: false,
      isInvalidExitTimeAlertVisible: false,
      isMissingExitWithAlertVisible: false,
      isInvalidSelfDeciderTimesAlertVisible: false,
      isEntryTimeClicked: false,
      isExitTimeClicked: false,
      isSpareTimeActivityVisible: false,
      isEntryTimeOutsideOpenHoursAlertVisible: false,
      isExitTimeOutsideOpenHoursAlertVisible: false,
      dateOfWeekFull: ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag'],
      templateForm: {
        config: {
          pickup: false,
          goHomeWith: false,
          selfDecider: false,
          sendHome: false,
          spareTimeActivity: false,
          dropOffTime: false,
        },
        shortDate: null,
        dayOfWeek: null,
        byDate: null,
        institutionProfileId: null,
        entryTime: '',
        exitTime: '',
        activityType: null,
        exitWith: null,
        selfDeciderStartTime: '',
        selfDeciderEndTime: '',
        comment: null,
        repeatToDate: null,
        defaultEndDate: null,
        repeatPattern: PresenceTemplateRepeatPatternEnum.NEVER,
      },
      availableEndDate: {},
      spareTimeActivity: {
        startTime: '',
        endTime: '',
        comment: '',
      },
      activeSFOChildrenIds: [],
      activeModules: [],
      deleteRepeatTemplate: null,
      warningDeleteRepeat: null,
      selectedDate: null,
      selectedTemplateInstitutionCode: null,
      defaultEntryTime: '08:00',
      defaultExitTime: '16:00',
      defaultSelfDeciderStartTime: '15:00',
      defaultSelfDeciderEndTime: '16:00',
    };
  },
  computed: {
    PresenceTemplateRepeatPatternEnum() {
      return PresenceTemplateRepeatPatternEnum;
    },
    iconClassEnum() {
      return iconClassEnum;
    },
    ...mapGetters({
      children: types.GET_CHILDREN,
      activeChildren: types.GET_ACTIVE_CHILDREN,
      institutions: types.GET_INSTITUTIONS,
      isMobile: types.GET_IS_MOBILE,
      getPresenceTimes: types.GET_PRESENCE_TIMES,
      defaultDateFormat: types.GET_DEFAULT_DATE_FORMAT,
      defaultDateValueFormat: types.GET_DEFAULT_DATE_VALUE_FORMAT,
      defaultTimeFormat: types.GET_DEFAULT_TIME_FORMAT,
      defaultTimeValuesFormat: types.GET_DEFAULT_TIME_VALUE_FORMAT,
      pickupResponsibles: types.GET_PICKUP_RESPONSIBLES,
      goHomeWithList: types.GET_GO_HOME_WITH_LIST,
      getPresenceStates: types.GET_PRESENCE_STATES_GUARDIAN,
      getPresenceActiveModules: types.GET_PRESENCE_ACTIVE_MODULES,
      openHours: types.GET_PRESENCE_OPEN_HOURS_GUARDIAN_DASHBOARD,
      holidayAndClosedDays: types.GET_HOLIDAY_CLOSED_DAY,
      selectedPresenceWeek: types.GET_SELECTED_PRESENCE_WEEK,
      overlappingPresenceTemplates: types.GET_OVERLAPPING_PRESENCE_TEMPLATES,
      hasCustodyOrExtendedAccess: types.GET_HAS_CUSTODY_OR_EXTENDED_ACCESS,
    }),
    isRepeating() {
      return [PresenceTemplateRepeatPatternEnum.WEEKLY, PresenceTemplateRepeatPatternEnum.EVERY_2_WEEKS].includes(
        this.templateForm.repeatPattern
      );
    },
    recurrenceInfo() {
      const pattern = this.templateForm.repeatPattern;
      switch (pattern) {
        case PresenceTemplateRepeatPatternEnum.WEEKLY:
        case PresenceTemplateRepeatPatternEnum.EVERY_2_WEEKS:
          return this.getRepeatingInfoWithStartWeek(this.templateForm);
        default:
          return '';
      }
    },
    presenceChildrenIds() {
      return this.presenceTimes.flatMap(presenceTime => presenceTime.presenceTimes.map(t => t.institutionProfile.id));
    },
    hasCommentReachedMaxCharacterLimit() {
      const comment = this.templateForm.comment;
      if (typeof comment !== 'string') {
        return false;
      }
      return comment.length >= 250;
    },
    timepickerStart() {
      const selectedInstitution = this.openHours.openingHoursOverviewDto.find(
        institution => institution.institutionCode == this.selectedTemplateInstitutionCode
      );
      const dateOfWeek = selectedInstitution?.openingHoursDto.find(
        hour => hour.date.localeCompare(this.selectedDate) === 0
      );
      if (
        dateOfWeek &&
        (dateOfWeek.type === presenceOpenHours.SPECIFIC_OPEN_HOURS ||
          dateOfWeek.type === presenceOpenHours.GENERAL_OPEN_HOURS)
      ) {
        return dateOfWeek.openTime;
      }
      return comeGoUtil.defaultStart();
    },
    timepickerEnd() {
      const selectedInstitution = this.openHours.openingHoursOverviewDto.find(
        institution => institution.institutionCode == this.selectedTemplateInstitutionCode
      );
      const dateOfWeek = selectedInstitution?.openingHoursDto.find(
        hour => hour.date.localeCompare(this.selectedDate) === 0
      );
      if (
        dateOfWeek &&
        (dateOfWeek.type === presenceOpenHours.SPECIFIC_OPEN_HOURS ||
          dateOfWeek.type === presenceOpenHours.GENERAL_OPEN_HOURS)
      ) {
        return dateOfWeek.closeTime;
      }
      return comeGoUtil.defaultEnd();
    },
    selectedDateOpenHours() {
      if (!this.selectedTemplateInstitutionCode && !this.selectedDate) {
        return null;
      }
      const selectedInstitutionOpenHours = this.openHours.openingHoursOverviewDto.find(
        institution => institution.institutionCode === this.selectedTemplateInstitutionCode
      );
      return selectedInstitutionOpenHours?.openingHoursDto.find(hour => moment(hour.date).isSame(this.selectedDate));
    },
    isSpecificOpenHours() {
      return this.selectedDateOpenHours?.type === presenceOpenHours.SPECIFIC_OPEN_HOURS;
    },
    getInstitutionSpecificOpenHours() {
      const selectedInstitution = this.openHours.openingHoursOverviewDto.find(
        institution => institution.institutionCode == this.selectedTemplateInstitutionCode
      );
      const dateOfWeek = selectedInstitution?.openingHoursDto.find(
        hour => hour.date.localeCompare(this.selectedDate) === 0
      );
      if (dateOfWeek && dateOfWeek.type === presenceOpenHours.SPECIFIC_OPEN_HOURS) {
        return dateOfWeek.openTime + ' - ' + dateOfWeek.closeTime;
      }
      return '';
    },
    presenceChildren() {
      let activeChildren = [];
      const children = this.getPresenceStates.filter(child => this.activeChildren.includes(child.uniStudentId));
      const presenceChildIds = children.map(i => i.uniStudentId);
      activeChildren = this.children.filter(child => presenceChildIds.includes(child.id));
      return activeChildren;
    },
    showInvalidSelfDeciderExitTimeAlert() {
      if (!this.isSelfDeciderEnabledModule) {
        return false;
      }
      if (
        this.templateForm.selfDeciderStartTime &&
        this.templateForm.selfDeciderEndTime &&
        this.templateForm.activityType == exitTypes.SELF_DECIDER
      ) {
        const startTime = moment(this.templateForm.selfDeciderStartTime, 'HH:mm', true);
        const endTime = moment(this.templateForm.selfDeciderEndTime, 'HH:mm', true);
        if (!startTime.isValid() || !endTime.isValid() || endTime.isSameOrBefore(startTime)) {
          return true;
        }
      }
      return false;
    },
    showInvalidActivityExitTimeAlert() {
      if (
        this.isSpareTimeActivityVisible &&
        this.spareTimeActivity &&
        this.spareTimeActivity.startTime &&
        this.spareTimeActivity.endTime
      ) {
        const startTime = moment(this.spareTimeActivity.startTime, 'HH:mm', true);
        const endTime = moment(this.spareTimeActivity.endTime, 'HH:mm', true);
        if (!startTime.isValid() || !endTime.isValid() || endTime.isSameOrBefore(startTime)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    presenceColsCss() {
      let css = 'coloumn1';
      if (!this.isSeparately) {
        css = 'coloumn' + this.getPresenceTimes.presenceWeekTemplates.length;
      }
      return css;
    },
    isSeparately() {
      return this.getPresenceTimes.presenceWeekTemplates.length > 3 || this.isMobile;
    },
    showInvalidSelfDeciderStartTimeAlert() {
      if (!this.isSelfDeciderEnabledModule) {
        return false;
      }

      if (!this.templateForm.selfDeciderStartTime) {
        return true;
      }

      if (!this.templateForm.entryTime) {
        return false;
      }

      if (this.templateForm.activityType === exitTypes.SELF_DECIDER) {
        const [selfDeciderStartHours, selfDeciderStartMinutes] = this.templateForm.selfDeciderStartTime.split(':');
        const [entryTimeHours, entryTimeMinutes] = this.templateForm.entryTime.split(':');
        const selfDeciderStart = moment().hours(selfDeciderStartHours).minutes(selfDeciderStartMinutes);
        const entryTime = moment().hours(entryTimeHours).minutes(entryTimeMinutes);
        return selfDeciderStart.isSameOrBefore(entryTime);
      }

      return false;
    },
    isSelfDeciderEnabledModule() {
      return this.activeModules.includes(exitTypes.SELF_DECIDER);
    },
    isEndDateDefinedInOverlappingPresenceTemplate() {
      const endDate = this.overlappingPresenceTemplates?.endDate;
      return endDate != null && endDate !== '';
    },
  },
  methods: {
    ...mapMutations({
      setSelectedPresenceWeek: types.MUTATE_SELECTED_PRESENCE_WEEK,
    }),
    ...mapActions({
      loadPresenceTimes: types.LOAD_PRESENCE_TIMES,
      updatePresenceTemplate: types.UPDATE_PRESENCE_TEMPLATE,
      loadPickupResponsibles: types.LOAD_PICKUP_RESPONSIBLES,
      loadGoHomeWithList: types.LOAD_GO_HOME_WITH_LIST,
      loadPresenceConfigurationByChildIds: types.LOAD_PRESENCE_CONFIGURATIONS_CHILD_IDS,
      savePickupResponsibles: types.SAVE_PICKUP_RESPONSIBLES,
      deleteRepeatingPresenceTemplate: types.DELETE_REPEATING_PRESENCE_TEMPLATE,
      loadOpenHoursForDay: types.LOAD_PRESENCE_OPEN_HOURS_GUARDIAN_DASHBOARD,
      loadHolidayAndClosedDays: types.LOAD_HOLIDAY_CLOSED_DAY,
      loadOverlappingPresenceTemplates: types.LOAD_OVERLAPPING_PRESENCE_TEMPLATES,
      resetOverlappingPresenceTemplates: types.RESET_OVERLAPPING_PRESENCE_TEMPLATES,
    }),
    getCanEditPresenceTemplate(presenceDate, profile, dayIndex) {
      const isOnVacation = Boolean(profile.dayTemplates[dayIndex]?.isOnVacation);
      return (
        !isOnVacation &&
        dateUtil.isTodayOrAfter(presenceDate.date) &&
        this.hasCustodyOrExtendedAccess(profile.institutionProfile.id)
      );
    },
    handleRepeatingPatternChange(pattern) {
      this.isPatternChanged = true;
      switch (pattern) {
        case PresenceTemplateRepeatPatternEnum.NEVER:
          this.resetOverlappingPresenceTemplates();
          break;
        default:
          this.updateOverlappingPresenceTemplates();
      }
    },
    onUpdateToDate() {
      this.isPatternChanged = true;
      this.updateOverlappingPresenceTemplates();
    },
    updateOverlappingPresenceTemplates() {
      let endDate = null;
      if (this.templateForm.repeatToDate != null) {
        endDate = moment(this.templateForm.repeatToDate, this.repeatDateFormat).format(dateFormatEnum.COMPLETE_DATE);
      }
      this.loadOverlappingPresenceTemplates({
        institutionProfileId: this.templateForm.institutionProfileId,
        startDate: moment(this.templateForm.byDate, this.repeatDateFormat).format(dateFormatEnum.COMPLETE_DATE),
        endDate,
        repeatPattern: this.templateForm.repeatPattern,
      });
    },
    getSelfDeciderClass(profile, dayIndex) {
      return (
        profile.dayTemplates[dayIndex].isPlannedTimesOutsideOpeningHours === true &&
        (!this.isTimeBetween(
          profile.dayTemplates[dayIndex].selfDeciderStartTime,
          profile.dayTemplates[dayIndex],
          profile.institutionProfile.institutionCode,
          profile.dayTemplates[dayIndex].activityType
        ) ||
          !this.isTimeBetween(
            profile.dayTemplates[dayIndex].selfDeciderEndTime,
            profile.dayTemplates[dayIndex],
            profile.institutionProfile.institutionCode,
            profile.dayTemplates[dayIndex].activityType
          ))
      );
    },
    showSelfDecider(child) {
      return !!(
        this.getPresenceActiveModules.selfDecider.includes(child.institutionProfile.id) &&
        child.selfDeciderStartTime &&
        child.selfDeciderEndTime
      );
    },
    confirmToDeleteRepetition(presenceIndex, profileIndex, dayIndex) {
      this.deleteRepeatTemplate = this.presenceTimes[presenceIndex].presenceTimes[profileIndex].dayTemplates[dayIndex];
      if (this.deleteRepeatTemplate.repeatToDate == null) {
        this.warningDeleteRepeat = this.$getText('PRESENCE_WARNING_DELETE_A_REPETITION_WITHOUT_END_DATE', {
          byDate: DateTimeUtil.formatDate(this.deleteRepeatTemplate.byDate, 'DD-MM-YYYY'),
        });
      } else {
        this.warningDeleteRepeat = this.$getText('PRESENCE_WARNING_DELETE_A_REPETITION_WITH_END_DATE', {
          byDate: DateTimeUtil.formatDate(this.deleteRepeatTemplate.byDate, 'DD-MM-YYYY'),
          repeatToDate: moment(this.deleteRepeatTemplate.repeatToDate).format('DD-MM-YYYY'),
        });
      }
      this.$refs.warningDeleteRepetition.show();
    },
    cancelDeleteRepetition() {
      this.deleteRepeatTemplate = null;
      this.warningDeleteRepeat = null;
      this.$refs.warningDeleteRepetition.hide();
    },
    async deleteRepetition() {
      const deleteFromDay = moment(this.deleteRepeatTemplate.byDate).format(dateFormatEnum.COMPLETE_DATE);
      await this.deleteRepeatingPresenceTemplate({
        presentTemplateId: this.deleteRepeatTemplate.id,
        deleteFromDay: deleteFromDay,
      });
      this.$refs.warningDeleteRepetition.hide();
      this.currentWeekView = this.presenceTimes.map(p => p.chosenWeek);
      const childIds = this.presenceChildren.map(child => child.id);
      if (childIds.length === 0) {
        return;
      }
      await this.loadChildrenPresenceTimes(
        childIds,
        dateUtil.startOfWeek(deleteFromDay),
        dateUtil.endOfWeek(deleteFromDay)
      );
      await this.keepCurrentWeekView();
    },
    openDatePicker() {
      if (this.$refs.chooseWeekDatepicker) {
        if ($('.presence-choose-week-popper').is(':visible')) {
          this.$refs.chooseWeekDatepicker[0].blur();
        } else {
          this.$refs.chooseWeekDatepicker[0].handleFocus();
        }
      }
    },
    saveNewPickupResponsible() {
      this.isPatternChanged = true;
      if (this.newPickupResponsible.trim().length < 2) {
        this.showAlertTooShortName = true;
      } else {
        this.savePickupResponsibles({
          uniStudentIds: [this.templateForm.institutionProfileId],
          pickupName: this.newPickupResponsible,
        }).then(() => {
          this.loadPickupResponsibles({
            uniStudentIds: [this.templateForm.institutionProfileId],
          });
          this.templateForm.exitWith = this.newPickupResponsible;
          this.newPickupResponsible = '';
        });
      }
    },
    changeEntryTime() {
      this.isPatternChanged = true;
      if (!this.templateForm.entryTime) {
        this.isMissingEntryTimeAlertVisible = true;
      } else {
        this.isInvalidExitTimeAlertVisible = false;
        this.validateTimeRange();
        if (this.templateForm.activityType === exitTypes.SELF_DECIDER) {
          this.validateEntryTimeAgainstSelfDeciderTimes();
        }
        if (this.templateForm.activityType !== exitTypes.SELF_DECIDER) {
          this.validateEntryTimeAgainstExitTime();
        }
      }
    },
    changeExitTime() {
      this.isMissingExitTimeAlertVisible = false;
      this.isExitTimeOutsideOpenHoursAlertVisible = false;
      this.isPatternChanged = true;
      if (
        !this.templateForm.exitTime &&
        !this.templateForm.selfDeciderStartTime &&
        !this.templateForm.selfDeciderEndTime
      ) {
        this.isMissingExitTimeAlertVisible = true;
        this.isInvalidExitTimeAlertVisible = false;
        return;
      }
      this.validateTimeRange();
      if (this.templateForm.activityType === exitTypes.SELF_DECIDER) {
        this.validateSelfDeciderTimes();
      } else {
        this.validateEntryTimeAgainstExitTime();
      }
    },
    validateEntryTimeAgainstSelfDeciderTimes() {
      if (this.templateForm.selfDeciderStartTime != null && this.templateForm.selfDeciderEndTime != null) {
        const entryTime = moment()
          .hours(this.templateForm.entryTime.split(':')[0])
          .minutes(this.templateForm.entryTime.split(':')[1]);
        const selfDeciderStartTime = moment()
          .hours(this.templateForm.selfDeciderStartTime.split(':')[0])
          .minutes(this.templateForm.selfDeciderStartTime.split(':')[1]);
        const selfDeciderEndTime = moment()
          .hours(this.templateForm.selfDeciderEndTime.split(':')[0])
          .minutes(this.templateForm.selfDeciderEndTime.split(':')[1]);
        if (entryTime.isAfter(selfDeciderStartTime) || entryTime.isSameOrAfter(selfDeciderEndTime)) {
          this.isMissingEntryTimeAlertVisible = false;
          this.isInvalidExitTimeAlertVisible = true;
        } else {
          this.isInvalidExitTimeAlertVisible = false;
        }
      }
    },
    validateEntryTimeAgainstExitTime() {
      if (this.templateForm.entryTime && this.templateForm.exitTime) {
        const entryTime = moment()
          .hours(this.templateForm.entryTime.split(':')[0])
          .minutes(this.templateForm.entryTime.split(':')[1]);
        const exitTime = moment()
          .hours(this.templateForm.exitTime.split(':')[0])
          .minutes(this.templateForm.exitTime.split(':')[1]);
        if (entryTime.isSameOrAfter(exitTime)) {
          this.isInvalidExitTimeAlertVisible = true;
          this.isMissingExitTimeAlertVisible = false;
          this.isMissingEntryTimeAlertVisible = false;
        } else {
          this.isInvalidExitTimeAlertVisible = false;
          this.isMissingExitTimeAlertVisible = false;
          this.isMissingEntryTimeAlertVisible = false;
        }
      }
    },
    validateSelfDeciderTimes() {
      if (this.templateForm.selfDeciderStartTime != null && this.templateForm.selfDeciderEndTime != null) {
        const selfDeciderStartTime = moment()
          .hours(this.templateForm.selfDeciderStartTime.split(':')[0])
          .minutes(this.templateForm.selfDeciderStartTime.split(':')[1]);
        const selfDeciderEndTime = moment()
          .hours(this.templateForm.selfDeciderEndTime.split(':')[0])
          .minutes(this.templateForm.selfDeciderEndTime.split(':')[1]);

        this.isInvalidSelfDeciderTimesAlertVisible = selfDeciderEndTime.isSameOrBefore(selfDeciderStartTime);

        if (this.templateForm.entryTime) {
          const entryTime = moment()
            .hours(this.templateForm.entryTime.split(':')[0])
            .minutes(this.templateForm.entryTime.split(':')[1]);

          if (entryTime.isAfter(selfDeciderStartTime) || entryTime.isSameOrAfter(selfDeciderEndTime)) {
            this.isInvalidExitTimeAlertVisible = true;
            this.isMissingExitTimeAlertVisible = false;
            this.isMissingEntryTimeAlertVisible = false;
          } else {
            this.isMissingExitTimeAlertVisible = false;
            this.isInvalidExitTimeAlertVisible = false;
          }
        }
      }
    },
    isOverlappingOldTemplate() {
      return this.overlappingPresenceTemplates != null;
    },
    onBeforeSubmitEditTemplate(event) {
      event?.preventDefault();
      if (this.isRepeating && this.isOverlappingOldTemplate()) {
        this.$refs.warningSaveOverlappingTemplate.show();
        return;
      }

      this.validateEditingTemplate();
    },
    validateEditingTemplate() {
      let isSave = true;
      if (this.isInvalidSelfDeciderTimesAlertVisible) {
        isSave = false;
      }
      if (this.showInvalidSelfDeciderStartTimeAlert === true) {
        isSave = false;
      }
      if (this.isInvalidExitTimeAlertVisible === true) {
        isSave = false;
      }
      if (
        moment(this.templateForm.byDate, dateFormatEnum.COMPLETE_DATE).isBefore(moment(), 'days') ||
        (this.isRepeating && moment(this.templateForm.repeatToDate).isBefore(moment(), 'days'))
      ) {
        isSave = false;
        this.$refs.warningUpdate.show();
      }
      if (!this.templateForm.entryTime && this.templateForm.config.dropOffTime) {
        isSave = false;
        this.isMissingEntryTimeAlertVisible = true;
      }

      this.validateTimeRange();
      if (
        (this.templateForm.config.dropOffTime === true && this.isEntryTimeOutsideOpenHoursAlertVisible) ||
        (this.templateForm.config.pickupTime && this.isExitTimeOutsideOpenHoursAlertVisible)
      ) {
        isSave = false;
      }

      if (
        this.templateForm.config.pickupTime &&
        !this.templateForm.exitTime &&
        ((this.templateForm.config.sendHome && this.templateForm.activityType == exitTypes.SEND_HOME) ||
          (this.templateForm.config.goHomeWith && this.templateForm.activityType == exitTypes.GO_HOME_WITH) ||
          (this.templateForm.config.pickup && this.templateForm.activityType == exitTypes.PICKED_UP_BY))
      ) {
        isSave = false;
        this.isMissingExitTimeAlertVisible = true;
      }
      if (
        !this.templateForm.exitWith &&
        ((this.templateForm.config.goHomeWith && this.templateForm.activityType == exitTypes.GO_HOME_WITH) ||
          (this.templateForm.config.pickup && this.templateForm.activityType == exitTypes.PICKED_UP_BY))
      ) {
        isSave = false;
        this.isMissingExitWithAlertVisible = true;
      }
      if (this.showInvalidSelfDeciderExitTimeAlert) {
        isSave = false;
      }
      if (this.showInvalidActivityExitTimeAlert) {
        isSave = false;
      }
      if (
        isSave &&
        this.templateForm.entryTime &&
        this.templateForm.config.dropOffTime &&
        this.templateForm.exitTime &&
        (this.templateForm.activityType == exitTypes.SEND_HOME ||
          this.templateForm.activityType == exitTypes.GO_HOME_WITH ||
          this.templateForm.activityType == exitTypes.PICKED_UP_BY)
      ) {
        const entryTime = moment()
          .hours(this.templateForm.entryTime.split(':')[0])
          .minutes(this.templateForm.entryTime.split(':')[1]);
        const exitTime = moment()
          .hours(this.templateForm.exitTime.split(':')[0])
          .minutes(this.templateForm.exitTime.split(':')[1]);
        if (entryTime.isSameOrAfter(exitTime)) {
          isSave = false;
          this.isInvalidExitTimeAlertVisible = true;
        }
      }

      if (isSave) {
        this.updateTemplate();
      }
    },
    preparePresenceTemplateParams() {
      const params: any = {
        institutionProfileId: this.templateForm.institutionProfileId,
        byDate: this.templateForm.byDate,
        presenceActivity: {},
        comment: this.templateForm.comment,
        repeatPattern: this.templateForm.repeatPattern,
        expiresAt: this.templateForm.repeatToDate,
      };

      const presenceActivityData: any = {};
      if (this.templateForm.activityType !== null) {
        presenceActivityData.activityType = this.templateForm.activityType;
        const entryTime = this.templateForm.config.dropOffTime ? this.templateForm.entryTime : null;
        const exitTime = this.templateForm.config.pickupTime ? this.templateForm.exitTime : null;

        switch (this.templateForm.activityType) {
          case exitTypes.PICKED_UP_BY:
            presenceActivityData.pickup = {
              entryTime: entryTime,
              exitTime: exitTime,
              exitWith: this.templateForm.exitWith,
            };
            break;
          case exitTypes.SELF_DECIDER:
            presenceActivityData.selfDecider = {
              entryTime: entryTime,
              exitStartTime: this.templateForm.selfDeciderStartTime,
              exitEndTime: this.templateForm.selfDeciderEndTime,
            };
            break;
          case exitTypes.SEND_HOME:
            presenceActivityData.sendHome = {
              entryTime: entryTime,
              exitTime: exitTime,
            };
            break;
          case exitTypes.GO_HOME_WITH:
            presenceActivityData.goHomeWith = {
              entryTime: entryTime,
              exitTime: exitTime,
              exitWith: this.templateForm.exitWith,
            };
            break;
          default:
            presenceActivityData.activityType = null;
            presenceActivityData.entryTime = entryTime;
            presenceActivityData.exitTime = exitTime;
            break;
        }
      }

      if (this.isSpareTimeActivityVisible) {
        params.spareTimeActivity = {
          startDate: this.spareTimeActivity.startTime,
          endDate: this.spareTimeActivity.endTime,
          comment: this.spareTimeActivity.comment,
        };
      }

      params.presenceActivity = presenceActivityData;
      return params;
    },
    async updateTemplate() {
      this.isEditingLoading = true;
      const params = this.preparePresenceTemplateParams();

      this.currentWeekView = this.presenceTimes.map(p => p.chosenWeek);
      const institutionProfileIds =
        this.activeSFOChildrenIds.length > 0 ? this.activeSFOChildrenIds : [this.viewPresenceProfile.id];

      await this.updatePresenceTemplate(params);
      this.isEditingLoading = false;
      this.closeEditDayTemplate();

      await this.loadChildrenPresenceTimes(
        institutionProfileIds,
        dateUtil.startOfWeek(params.byDate),
        dateUtil.endOfWeek(params.byDate)
      );
      await this.keepCurrentWeekView();
    },
    async keepCurrentWeekView() {
      this.isLoadingTemplate = true;
      this.initPresenceTimes();
      if (this.viewPresenceProfile) {
        const presenceDates = this.getPresenceDates();
        this.populateChildPresenceTimes(this.viewPresenceProfile.id, presenceDates);
      }
      if (this.currentWeekView.length === 0) {
        return;
      }

      let index = 0;
      for (const week of this.currentWeekView) {
        if (week === null || this.presenceTimes[index] === null) {
          index++;
          continue;
        }
        this.presenceTimes[index].chosenWeek = this.currentWeekView[index];
        const chosenDate = this.presenceTimes[index].chosenWeek ?? this.getPresenceTimes.currentDate;
        const viewWeek = moment(chosenDate).format('W');
        if (viewWeek === this.presenceTimes[index].presenceWeek.toString()) {
          continue;
        }
        this.changeWeekViewPresenceTimes(index);
        this.updateDayTemplates();
        index++;
      }

      await this.getOpenHoursForDay();
      this.resetLoading();
    },
    resetForm() {
      this.isMissingEntryTimeAlertVisible = false;
      this.isMissingExitTimeAlertVisible = false;
      this.isInvalidExitTimeAlertVisible = false;
      this.isMissingExitWithAlertVisible = false;
      this.isInvalidSelfDeciderTimesAlertVisible = false;
      this.isPatternChanged = false;
    },
    isTimeBetween(time, date, institutionCode, type) {
      if (type === exitTypes.SELF_DECIDER || type == null) {
        const specificOpenHours = cloneDeep(this.getSpecificOpenHours(date, institutionCode));

        if (specificOpenHours == null) {
          return false;
        }

        const momentOpenHour = moment(specificOpenHours.split(' - ')[0], 'HH:mm:ss');
        const momentCloseHour = moment(specificOpenHours.split(' - ')[1], 'HH:mm:ss');
        return moment(time, 'HH:mm:ss').isBetween(momentOpenHour, momentCloseHour, undefined, '[]');
      }
      return false;
    },
    closeEditDayTemplate() {
      this.$refs.editTemplate.hide();
    },
    handleTemplateShown() {
      this.$root.$emit('bv::hide::tooltip');
    },
    handleTemplateHidden() {
      this.resetOverlappingPresenceTemplates();
      this.isExitTimeOutsideOpenHoursAlertVisible = false;
      this.isEntryTimeOutsideOpenHoursAlertVisible = false;
      this.isEditingTemplate = false;
    },
    editingDayTemplate(presenceIndex, profileIndex, dayIndex, repeatPattern = PresenceTemplateRepeatPatternEnum.NEVER) {
      this.editTemplatePresenceIndex = presenceIndex;
      this.editTemplateProfileIndex = profileIndex;
      this.editTemplateDayIndex = dayIndex;
      const dayTemplate = this.presenceTimes[presenceIndex].presenceTimes[profileIndex].dayTemplates[dayIndex];
      const chosenDate = this.presenceTimes[presenceIndex].presenceDates[dayIndex].date;
      const profileTemplates = this.presenceTimes[presenceIndex].presenceTimes[profileIndex];
      let templateId = null;
      const editTemplate = profileTemplates.dayTemplates.filter(t => DateTimeUtil.isSame(t.byDate, chosenDate));

      this.selectedDate = chosenDate;
      this.selectedTemplateInstitutionCode = profileTemplates.institutionProfile.institutionCode;

      const selectedInstitution = this.openHours.openingHoursOverviewDto.find(
        institution => institution.institutionCode == this.selectedTemplateInstitutionCode
      );
      const dateOfWeek = selectedInstitution?.openingHoursDto.find(
        hour => hour.date.localeCompare(this.selectedDate) === 0
      );

      if (editTemplate.length > 0) {
        templateId = editTemplate[0].id;
      }
      this.activeModules = [];
      if (profileTemplates.pickup) {
        this.activeModules.push({
          value: exitTypes.PICKED_UP_BY,
          label: this.$getText('PRESENCE_PICKUP_TYPE_PICKUP'),
        });
      }
      if (profileTemplates.selfDecider) {
        this.activeModules.push({
          value: exitTypes.SELF_DECIDER,
          label: this.$getText('PRESENCE_PICKUP_TYPE_SELF_DECIDER'),
        });
      }
      if (profileTemplates.sendHome) {
        this.activeModules.push({
          value: exitTypes.SEND_HOME,
          label: this.$getText('PRESENCE_PICKUP_TYPE_SEND_HOME'),
        });
      }
      if (profileTemplates.goHomeWith) {
        this.activeModules.push({
          value: exitTypes.GO_HOME_WITH,
          label: this.$getText('PRESENCE_PICKUP_TYPE_GO_HOME_WITH'),
        });
      }
      this.editPresenceProfile = profileTemplates.institutionProfile;
      dayTemplate.institutionProfileId = profileTemplates.institutionProfile.id;
      dayTemplate.byDate = this.presenceTimes[presenceIndex].presenceDates[dayIndex].date;
      dayTemplate.shortDate = moment(dayTemplate.byDate).format('DD.MMMM');
      dayTemplate.config = {};
      dayTemplate.profileIndex = profileIndex;
      dayTemplate.config.pickup = profileTemplates.pickup;
      dayTemplate.config.goHomeWith = profileTemplates.goHomeWith;
      dayTemplate.config.selfDecider = profileTemplates.selfDecider;
      dayTemplate.config.sendHome = profileTemplates.sendHome;
      dayTemplate.config.spareTimeActivity = profileTemplates.spareTimeActivity;
      dayTemplate.config.dropOffTime = profileTemplates.dropOffTime;
      dayTemplate.config.pickupTime = profileTemplates.pickupTime;
      dayTemplate.id = templateId;
      this.templateForm = Object.assign(this.templateForm, dayTemplate);
      this.templateForm.exitTime = this.templateForm.exitTime ?? '';
      this.templateForm.entryTime = this.templateForm.entryTime ?? '';
      this.templateForm.selfDeciderStartTime = this.templateForm.selfDeciderStartTime ?? '';
      this.templateForm.selfDeciderEndTime = this.templateForm.selfDeciderEndTime ?? '';
      this.templateForm.repeatPattern = repeatPattern;
      this.availableEndDate = {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return moment(time).isBefore(moment(dayTemplate.byDate));
        },
      };
      this.templateForm.defaultEndDate = moment(dayTemplate.byDate, 'YYYY-MM-DD').format(dateFormatEnum.COMPLETE_DATE);
      if (this.templateForm.config.goHomeWith) {
        this.loadGoHomeWithList({
          institutionProfileId: this.templateForm.institutionProfileId,
        });
      }

      if (
        dateOfWeek &&
        (dateOfWeek.type === presenceOpenHours.SPECIFIC_OPEN_HOURS ||
          dateOfWeek.type === presenceOpenHours.GENERAL_OPEN_HOURS)
      ) {
        this.validateTimeRange();

        if (this.templateForm.config.selfDecider === true) {
          const closeTime = dateOfWeek.closeTime;
          if (this.templateForm.selfDeciderEndTime == null && this.templateForm.selfDeciderStartTime == null) {
            this.templateForm.selfDeciderEndTime = closeTime;
            this.templateForm.selfDeciderStartTime = closeTime.split(':')[0] - 1 + ':' + closeTime.split(':')[1];
          }
        }
      } else {
        if (this.templateForm.selfDeciderEndTime == null && this.templateForm.selfDeciderStartTime == null) {
          this.templateForm.selfDeciderStartTime = this.defaultSelfDeciderStartTime;
          this.templateForm.selfDeciderEndTime = this.defaultSelfDeciderEndTime;
        }
      }
      if (this.templateForm.config.pickup) {
        this.loadPickupResponsibles({
          uniStudentIds: [this.templateForm.institutionProfileId],
        });
      }
      if (this.templateForm.config.spareTimeActivity && this.templateForm.spareTimeActivity == null) {
        this.isSpareTimeActivityVisible = false;
        this.spareTimeActivity.startTime = '13:00';
        this.spareTimeActivity.endTime = '14:00';
        this.spareTimeActivity.comment = '';
      } else if (
        this.templateForm.config.spareTimeActivity &&
        this.templateForm.spareTimeActivity != null &&
        this.templateForm.spareTimeActivity.startTime != '' &&
        this.templateForm.spareTimeActivity.endTime != ''
      ) {
        this.spareTimeActivity.startTime = this.templateForm.spareTimeActivity.startTime;
        this.spareTimeActivity.endTime = this.templateForm.spareTimeActivity.endTime;
        this.spareTimeActivity.comment = this.templateForm.spareTimeActivity.comment;
        this.isSpareTimeActivityVisible = true;
      } else if (!this.templateForm.config.spareTimeActivity) {
        this.isSpareTimeActivityVisible = false;
        this.spareTimeActivity = {
          startTime: null,
          endTime: null,
          comment: '',
        };
      }
      if (this.templateForm.activityType == null && this.activeModules.length > 0) {
        this.templateForm.activityType = this.activeModules[0].value;
      } else {
        if (this.templateForm.activityType === exitTypes.PICKED_UP_BY && !this.templateForm.config.pickup) {
          this.templateForm.activityType = exitTypes.SELF_DECIDER;
        }
        if (this.templateForm.activityType === exitTypes.SELF_DECIDER && !this.templateForm.config.selfDecider) {
          this.templateForm.activityType = exitTypes.SEND_HOME;
        }
        if (this.templateForm.activityType === exitTypes.SEND_HOME && !this.templateForm.config.sendHome) {
          this.templateForm.activityType = exitTypes.GO_HOME_WITH;
        }
      }

      if (this.templateForm.byDate && this.isRepeating) {
        this.updateOverlappingPresenceTemplates();
      }

      this.resetForm();
      this.isEditingTemplate = true;
      this.$refs.editTemplate.show();
      this.setUpDefaultTimeForTemplate();
    },
    setUpDefaultTimeForTemplate() {
      if (!this.selectedDateOpenHours || this.templateForm.entryTime) {
        return;
      }
      if (this.selectedDateOpenHours.type === presenceOpenHours.DEFAULT_OPEN_HOURS) {
        this.templateForm.entryTime = this.defaultEntryTime;
        this.templateForm.exitTime = this.defaultExitTime;
        this.templateForm.selfDeciderStartTime = this.defaultSelfDeciderStartTime;
        this.templateForm.selfDeciderEndTime = this.defaultSelfDeciderEndTime;
      } else {
        this.templateForm.entryTime = this.selectedDateOpenHours.openTime;
        this.templateForm.exitTime = this.selectedDateOpenHours.closeTime;
        this.templateForm.selfDeciderStartTime = DateTimeUtil.substractTimeWithFormat(
          this.selectedDateOpenHours.closeTime,
          dateFormatEnum.SHORT_TIME,
          1,
          'hours'
        );
        this.templateForm.selfDeciderEndTime = this.selectedDateOpenHours.closeTime;
      }
    },
    validateTimeRange() {
      const momentOpenHoursTime = moment(this.selectedDateOpenHours?.openTime, 'HH:mm:ss');
      const momentCloseHoursTime = moment(this.selectedDateOpenHours?.closeTime, 'HH:mm:ss');
      const momentEntryTime = moment(this.templateForm.entryTime, 'HH:mm:ss');
      const momentExitTime = moment(this.templateForm.exitTime, 'HH:mm:ss');
      const dateWeekIsOpeningHours = [
        presenceOpenHours.SPECIFIC_OPEN_HOURS,
        presenceOpenHours.GENERAL_OPEN_HOURS,
      ].includes(this.selectedDateOpenHours?.type);

      this.isEntryTimeOutsideOpenHoursAlertVisible = false;
      this.isExitTimeOutsideOpenHoursAlertVisible = false;

      if (dateWeekIsOpeningHours === false) {
        return;
      }

      if (this.templateForm.activityType === exitTypes.SELF_DECIDER) {
        if (this.templateForm.selfDeciderEndTime && this.templateForm.selfDeciderStartTime) {
          const momentSelftStart = moment(this.templateForm.selfDeciderStartTime, 'HH:mm:ss');
          const momentSelftEnd = moment(this.templateForm.selfDeciderEndTime, 'HH:mm:ss');

          // Sefl decider type has 2 departure time fields
          if (
            !momentSelftStart.isBetween(momentOpenHoursTime, momentCloseHoursTime, undefined, '[]') ||
            !momentSelftEnd.isBetween(momentOpenHoursTime, momentCloseHoursTime, undefined, '[]')
          ) {
            this.isExitTimeOutsideOpenHoursAlertVisible = true;
          }
          if (
            this.templateForm.entryTime &&
            !momentEntryTime.isBetween(momentOpenHoursTime, momentCloseHoursTime, undefined, '[]')
          ) {
            this.isEntryTimeOutsideOpenHoursAlertVisible = true;
          }
        }
      } else {
        if (
          this.templateForm.entryTime &&
          !momentEntryTime.isBetween(momentOpenHoursTime, momentCloseHoursTime, undefined, '[]')
        ) {
          this.isEntryTimeOutsideOpenHoursAlertVisible = true;
        }
        if (
          this.templateForm.exitTime &&
          !momentExitTime.isBetween(momentOpenHoursTime, momentCloseHoursTime, undefined, '[]')
        ) {
          this.isExitTimeOutsideOpenHoursAlertVisible = true;
        }
      }
    },
    updatePickUpType() {
      this.templateForm.exitWith = '';
      this.resetForm();
      this.isEntryTimeOutsideOpenHoursAlertVisible = false;
      this.isExitTimeOutsideOpenHoursAlertVisible = false;
      this.isPatternChanged = true;
    },
    getPresenceDates(date = null) {
      const viewDay =
        date === null
          ? moment().format(dateFormatEnum.COMPLETE_DATE_TIME)
          : moment(date).format(dateFormatEnum.COMPLETE_DATE_TIME);
      const presenceDays = [];
      let presenceDay = moment(viewDay).startOf('isoWeek');
      const endOfWeek = moment(viewDay).endOf('isoWeek');
      let dayOfWeek = presenceDay.isoWeekday();
      while (presenceDay.isSameOrBefore(endOfWeek) && dayOfWeek < 6) {
        presenceDays.push({
          date: presenceDay.format(dateFormatEnum.COMPLETE_DATE),
          shortDate: DateTimeUtil.date(dateFormatTypes.monthDay, presenceDay),
          dayOfWeek: DateTimeUtil.date(dateFormatTypes.shortWeekDateName, presenceDay),
          dateOfWeekFull: this.dateOfWeekFull[dayOfWeek - 1],
        });
        presenceDay = presenceDay.add(1, 'days');
        dayOfWeek = presenceDay.isoWeekday();
      }
      return presenceDays;
    },
    populateChildPresenceTimes(childId, presenceDates) {
      const presenceTemplate = this.getPresenceTimes.presenceWeekTemplates.find(
        t => t.institutionProfile.id == childId
      );
      if (presenceTemplate === null) {
        return;
      }
      if (this.getPresenceActiveModules != null) {
        for (const pickupType in pickupTypes) {
          presenceTemplate[pickupTypes[pickupType].paramName] =
            this.getPresenceActiveModules[pickupTypes[pickupType].paramName] != null &&
            this.getPresenceActiveModules[pickupTypes[pickupType].paramName].includes(
              presenceTemplate.institutionProfile.id
            );
        }
        presenceTemplate.dropOffTime =
          this.getPresenceActiveModules[presenceModules.DROP_OFF_TIME] != null &&
          this.getPresenceActiveModules[presenceModules.DROP_OFF_TIME].includes(presenceTemplate.institutionProfile.id);
        presenceTemplate.spareTimeActivity =
          this.getPresenceActiveModules[presenceModules.SPARE_TIME_ACTIVITY] != null &&
          this.getPresenceActiveModules[presenceModules.SPARE_TIME_ACTIVITY].includes(
            presenceTemplate.institutionProfile.id
          );
        presenceTemplate.pickupTime =
          this.getPresenceActiveModules[presenceModules.PICKUP_TIMES] != null &&
          this.getPresenceActiveModules[presenceModules.PICKUP_TIMES].includes(presenceTemplate.institutionProfile.id);
      }
      const presenceTime = {
        presenceDates: presenceDates,
        presenceWeek: moment().isoWeek(),
        presenceMonth: moment().format('MMMM'),
        chosenWeek: null,
        presenceTimes: [presenceTemplate],
      };
      this.presenceTimes = [presenceTime];
    },
    async loadChildrenPresenceTimes(childrenIds, fromDate, toDate) {
      await this.loadPresenceTimes({
        institutionProfileIds: childrenIds,
        fromDate: fromDate,
        toDate: toDate,
      });
    },
    async viewPresenceByChild(childId) {
      const presenceDates = this.getPresenceDates();
      this.viewPresenceProfile = this.children.find(c => c.id == childId);
      this.isLoadingTemplate = true;

      await this.loadChildrenPresenceTimes([childId], dateUtil.startOfWeek(), dateUtil.endOfWeek());
      this.populateChildPresenceTimes(childId, presenceDates);
      await this.getOpenHoursForDay();
      this.resetLoading();
    },
    setCurrentViewTemplate() {
      let presenceTimes = [];
      const presenceDates = this.getPresenceDates();
      if (!this.isSeparately) {
        for (let presenceTemplate of this.getPresenceTimes.presenceWeekTemplates) {
          presenceTemplate = this.setPresenceTemplateProps(presenceTemplate);
        }
        presenceTimes = [
          {
            presenceWeek: this.selectedPresenceWeek.presenceWeek
              ? this.selectedPresenceWeek.presenceWeek
              : moment().isoWeek(),
            presenceMonth: this.selectedPresenceWeek.presenceMonth
              ? this.selectedPresenceWeek.presenceMonth
              : moment().format('MMMM'),
            presenceDates: this.selectedPresenceWeek.presenceDates
              ? this.selectedPresenceWeek.presenceDates
              : presenceDates,
            chosenWeek: this.selectedPresenceWeek.chosenWeek ? this.selectedPresenceWeek.chosenWeek : null,
            presenceTimes: this.getPresenceTimes.presenceWeekTemplates,
          },
        ];
      } else {
        for (let presenceTemplate of this.getPresenceTimes.presenceWeekTemplates) {
          presenceTemplate = this.setPresenceTemplateProps(presenceTemplate);
          const presenceTime = {
            presenceWeek: this.selectedPresenceWeek.presenceWeek
              ? this.selectedPresenceWeek.presenceWeek
              : moment().isoWeek(),
            presenceMonth: this.selectedPresenceWeek.presenceMonth
              ? this.selectedPresenceWeek.presenceMonth
              : moment().format('MMMM'),
            presenceDates: this.selectedPresenceWeek.presenceDates
              ? this.selectedPresenceWeek.presenceDates
              : presenceDates,
            chosenWeek: this.selectedPresenceWeek.chosenWeek ? this.selectedPresenceWeek.chosenWeek : null,
            presenceTimes: [presenceTemplate],
          };
          presenceTimes.push(presenceTime);
        }
      }
      return presenceTimes;
    },
    setPresenceTemplateProps(presenceTemplate) {
      if (this.getPresenceActiveModules != null) {
        for (const pickupType in pickupTypes) {
          presenceTemplate[pickupTypes[pickupType].paramName] =
            this.getPresenceActiveModules[pickupTypes[pickupType].paramName] != null &&
            this.getPresenceActiveModules[pickupTypes[pickupType].paramName].includes(
              presenceTemplate.institutionProfile.id
            );
        }
        presenceTemplate.dropOffTime =
          this.getPresenceActiveModules[presenceModules.DROP_OFF_TIME] != null &&
          this.getPresenceActiveModules[presenceModules.DROP_OFF_TIME].includes(presenceTemplate.institutionProfile.id);
        presenceTemplate.spareTimeActivity =
          this.getPresenceActiveModules[presenceModules.SPARE_TIME_ACTIVITY] != null &&
          this.getPresenceActiveModules[presenceModules.SPARE_TIME_ACTIVITY].includes(
            presenceTemplate.institutionProfile.id
          );
        presenceTemplate.pickupTime =
          this.getPresenceActiveModules[presenceModules.PICKUP_TIMES] != null &&
          this.getPresenceActiveModules[presenceModules.PICKUP_TIMES].includes(presenceTemplate.institutionProfile.id);
      }
      return presenceTemplate;
    },
    initPresenceTimes() {
      if (this.getPresenceTimes.presenceWeekTemplates != null) {
        this.presenceTimes = this.setCurrentViewTemplate();
      }
      $('.presence-choose-week-picker').click(() => {
        if ($('.presence-choose-week-popper').is(':visible')) {
          this.$refs.chooseWeekDatePicker.blur();
        } else {
          this.$refs.chooseWeekDatePicker.handleFocus();
        }
      });
    },
    getIsCurrentDate(presenceDate) {
      return dateUtil.isToday(presenceDate);
    },
    changeWeekViewPresenceTimes(weekIndex) {
      const chosenDate = this.presenceTimes[weekIndex].chosenWeek ?? this.getPresenceTimes.currentDate;
      const viewWeek = moment(chosenDate).format('W');

      for (const presenceTime of this.presenceTimes) {
        presenceTime.presenceDates = this.getPresenceDates(chosenDate);
        presenceTime.presenceWeek = viewWeek;
        presenceTime.presenceMonth = moment(chosenDate).format('MMMM');
      }

      this.setSelectedPresenceWeek(this.presenceTimes[weekIndex]);
    },
    updateDayTemplates() {
      for (const presenceTime of this.presenceTimes) {
        for (const template of presenceTime.presenceTimes) {
          const child = this.getPresenceTimes.presenceWeekTemplates.find(
            t => t.institutionProfile.id === template.institutionProfile.id
          );
          if (child != null) {
            template.dayTemplates = child.dayTemplates;
          }
        }
      }
    },
    async changeWeekView(index) {
      const chosenDate = this.presenceTimes[index].chosenWeek ?? this.getPresenceTimes.currentDate;
      const viewWeek = moment(chosenDate).format('W');

      if (viewWeek === this.presenceTimes[index].presenceWeek.toString()) {
        return;
      }
      this.isLoadingTemplate = true;
      this.changeWeekViewPresenceTimes(index);
      await this.loadChildrenPresenceTimes(
        this.presenceChildrenIds,
        dateUtil.startOfWeek(chosenDate),
        dateUtil.endOfWeek(chosenDate)
      );
      this.updateDayTemplates();
      await this.getOpenHoursForDay();
      this.resetLoading();
    },
    loadPresenceConfiguration() {
      const activeSFOChildren = this.getPresenceStates.map(child => child.uniStudentId);
      if (activeSFOChildren.length > 0) {
        this.loadPresenceConfigurationByChildIds({
          childIds: activeSFOChildren,
        }).then(() => {
          this.getOpenHoursForDay();
          this.resetLoading();
        });
      }
    },
    loadPresenceTemplateByChildIds() {
      if (this.activeChildren.length > 0) {
        this.isLoading = true;
        this.isLoadingTemplate = true;
        const activeSFOChildren = this.getPresenceStates.filter(child =>
          this.activeChildren.includes(child.uniStudentId)
        );
        if (activeSFOChildren.length > 0) {
          this.activeSFOChildrenIds = activeSFOChildren.map(child => child.uniStudentId);
          const fromDate = dateUtil.startOfWeek();
          const toDate = dateUtil.endOfWeek();
          this.loadPresenceConfigurationByChildIds({
            childIds: this.activeSFOChildrenIds,
          }).then(() => {
            this.loadPresenceTimes({
              institutionProfileIds: this.activeSFOChildrenIds,
              fromDate: fromDate,
              toDate: toDate,
            }).then(() => {
              this.initPresenceTimes();
              this.getOpenHoursForDay();
              this.resetLoading();

              const activeChildren = this.children.filter(child => this.activeSFOChildrenIds.includes(child.id));
              const childInstitutionCodeList = Array.from(new Set(activeChildren.map(child => child.institutionCode)));

              this.loadHolidayAndClosedDays({
                institutionCodes: childInstitutionCodeList,
              });
            });
          });
        } else {
          this.resetLoading();
        }
      }
    },
    async getOpenHoursForDay() {
      if (this.presenceTimes.length === 0) {
        return;
      }
      const startDate = this.presenceTimes[0].presenceTimes[0].dayTemplates[0].byDate;
      const endDate = this.presenceTimes[0].presenceTimes[0].dayTemplates[4].byDate;
      const activeSFOChildren = this.getPresenceStates.filter(child =>
        this.activeChildren.includes(child.uniStudentId)
      );
      const activeSFOChildrenIds = activeSFOChildren.map(child => child.uniStudentId);
      const activeChildren = this.children.filter(child => activeSFOChildrenIds.includes(child.id));
      const childInstitutionCodeList = Array.from(new Set(activeChildren.map(child => child.institutionCode)));

      await this.loadOpenHoursForDay({
        startDate: startDate,
        endDate: endDate,
        institutionCodes: childInstitutionCodeList,
      });
    },
    resetLoading() {
      this.isLoading = false;
      this.isLoadingTemplate = false;
    },
    getSpecificOpenHours(date, institutionCode) {
      const selectedInstitution = this.openHours.openingHoursOverviewDto.find(
        institution => institution.institutionCode == institutionCode
      );
      let formattedDate;
      if (date.byDate.split('-')[0].length == 2) {
        formattedDate = date.byDate.split('-').reverse().join('-');
      } else {
        formattedDate = date.byDate;
      }
      const dateOfWeek = selectedInstitution?.openingHoursDto.find(
        hour => hour.date.localeCompare(formattedDate) === 0
      );
      if (dateOfWeek && dateOfWeek.type === presenceOpenHours.SPECIFIC_OPEN_HOURS) {
        return dateOfWeek.openTime + ' - ' + dateOfWeek.closeTime;
      }

      return null;
    },
    isClosedDayString(date, institutionCode) {
      const currentInstitution = this.holidayAndClosedDays.find(date => date.institutionCode === institutionCode);
      if (currentInstitution) {
        date = dateUtil.format(date, dateFormatEnum.COMPLETE_DATE);
        const isClosedDay = currentInstitution.closedDaysOverview.closedDays.find(closeDate => {
          const momentStartDate = moment(closeDate.startDate);
          const momentEndDate = moment(closeDate.endDate);

          return moment(date).isBetween(momentStartDate, momentEndDate, undefined, '[]');
        });

        if (isClosedDay) {
          return isClosedDay.name;
        }

        return null;
      }
    },
    isClosedDay(date, institutionCode) {
      const currentInstitution = this.holidayAndClosedDays.find(date => date.institutionCode === institutionCode);
      if (currentInstitution) {
        date = dateUtil.format(date, dateFormatEnum.COMPLETE_DATE);
        const isClosedDay = currentInstitution.closedDaysOverview.closedDays.find(closeDate => {
          const momentStartDate = moment(closeDate.startDate);
          const momentEndDate = moment(closeDate.endDate);

          return moment(date).isBetween(momentStartDate, momentEndDate, undefined, '[]');
        });

        if (isClosedDay) {
          return true;
        }
        return false;
      }
    },
    onSaveOverlappingTemplate() {
      this.$refs.warningSaveOverlappingTemplate.hide();
      this.validateEditingTemplate();
    },
    cancelSaveOverlappingTemplate() {
      this.$refs.warningSaveOverlappingTemplate.hide();
    },
  },
  watch: {
    children: function () {
      this.loadPresenceTemplateByChildIds();
    },
    isMobile: function () {
      this.viewPresenceProfile = null;
      if (!this.isMobile) {
        this.loadPresenceTemplateByChildIds();
      }
    },
    activeChildren: function () {
      this.loadPresenceTemplateByChildIds();
    },
    getPresenceActiveModules: function () {
      this.initPresenceTimes();
    },
  },
  mounted() {
    if (!this.isMobile) {
      this.loadPresenceTemplateByChildIds();
    } else {
      this.loadPresenceConfiguration();
    }
  },
  beforeDestroy() {
    this.setSelectedPresenceWeek({});
  },
};
